import type { FC } from 'react';

import { Icon } from '@zen/DesignSystem';

interface SuggestionPillProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string) => void;
  proposedValueText: string;
}

export const SuggestionPill: FC<SuggestionPillProps> = ({ id, proposedValueText, onAccept, onReject }) => {
  return (
    <div className="bg-sunrise-light rounded-4xl flex items-center px-2 gap-2 justify-between w-auto h-8 text-navy-dark mt-2">
      <div className="flex items-center gap-2">
        <Icon icon="zicon-sparkles-empty" />
        <span className="font-extrabold truncate max-w-40">{proposedValueText}</span> suggested
      </div>

      <div className="flex items-center gap-2">
        <Icon onClick={() => onAccept(id)} className="text-navy-dark right-4 cursor-pointer" icon="zicon-tick" />
        <Icon onClick={() => onReject(id)} className="text-navy-dark right-4 cursor-pointer" icon="zicon-close" />
      </div>
    </div>
  );
};
